import { Container } from '@/components/common/container';
import { ProductDetailsContent } from '.';

export function ProductDetailsPage() {
  return (
    <Container>
      <ProductDetailsContent />
    </Container>
  );
}
